//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            tableLoading: false,
            tableData: [],
            pagination: {},
            tableSorting: '',
            tableSearch: {
                name: '',
                email: ''
            },
            tableSearchFields: ['name', 'email'],
            demoUsers: {}
        };
    },

    computed: {
        params: function () {
            let params = {};

            if (this.tableSorting !== '' && this.tableSorting !== 'null|asc') {
                params.sort = this.tableSorting;
            }

            params.filter = [];
            _.each(this.tableSearchFields, field => {
                if (this.tableSearch[field] !== '') {
                    params.filter.push(field + '|%' + this.tableSearch[field] + '%');
                }
            });

            params.limit = this.pagination.perPage;
            params.page = this.pagination.currentPage;

            params.with = ['roles', 'results', 'classroom'];

            return params;
        }
    },

    mounted () {
        this.loadData();
    },

    methods: {
        loadData () {
            this.tableLoading = true;

            axios.get('users', {
                params: this.params
            })
                .then(response => {
                    this.tableData = response.data.data;
                    this.pagination = this.$helper.getPaginationData(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .then(() => {
                    this.tableLoading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        goToPage (page) {
            this.pagination.currentPage = page;
            this.loadData();
        },

        handleTableSort (data) {
            let order = 'asc';

            if (data.order === 'descending') {
                order = 'desc';
            }

            this.tableSorting = data.prop + '|' + order;
            this.loadData();
        },

        handleTableSearch () {
            this.loadData();
        },

        handleCreate () {
            this.demoUsers = {};
            this.$refs['userForm'].setItem(false);
            this.$refs['userForm'].show();
        },

        handleEdit (row) {
            this.demoUsers = {};
            this.$refs['userForm'].setItem(row);
            this.$refs['userForm'].show();
        },

        handleConfirmDelete: function (row) {
            this.demoUsers = {};
            this.$confirm(this.$lang.get('models.user.delete.text'), this.$lang.get('models.user.delete.confirm'), {
                confirmButtonText: 'Löschen',
                cancelButtonText: 'Abbrechen',
                type: 'warning'
            }).then(() => {
                this.delete(row);
            }).catch(error => {
                console.log(error);
            });
        },

        delete: function (row) {
            axios.delete('users/' + row.id)
                .then(response => {
                    this.loadData();
                    this.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },

        handleConfirmReset: function (row) {
            this.demoUsers = {};
            this.$confirm(this.$lang.get('models.user.reset.text'), this.$lang.get('models.user.reset.confirm'), {
                confirmButtonText: this.$lang.get('models.user.reset.button'),
                cancelButtonText: 'Abbrechen',
                type: 'warning'
            }).then(() => {
                this.reset(row);
            }).catch(error => {
                console.log(error);
            });
        },

        reset: function (row) {
            axios.put('users/' + row.id + '/reset')
                .then(response => {
                    this.loadData();
                    this.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },

        handleResults (row) {
            this.$refs['userResults'].setResults(row.results);
            this.$refs['userResults'].show();
        },

        showDemoUsers (users) {
            this.demoUsers = users;
        },

        downloadStatistic () {
            window.location.href = '/statistic/download';
        },

        downloadReason () {
            window.location.href = '/users/reason/download';
        },

        downloadRating () {
            window.location.href = '/users/ratings/download';
        },

        sendTestmail: function (row) {
            axios.get('/dev/testmail')
                .then(response => {
                    this.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
